import { KYMW6501Model } from '../kymw6501.model';
import { TimeSaleDataModel } from '../vo/time-sale-data.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * タイムセールマスタ更新
 *
 * @export API通信成功時の処理
 * @class UpdateCwsTimeSaleInfo
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateCwsTimeSaleInfoService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW6501Model;
  private successFunc: Function;
  private vo: TimeSaleDataModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateCwsTimeSaleInfo
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.OrderCode,
        CategoryCode: this.vo.CategoryCode,
        StartDateYMD: this.vo.StartDateYMD,
        StartDateHH: this.vo.StartDateHH,
        StartDateMI: this.vo.StartDateMI,
        EndDateYMD: this.vo.EndDateYMD,
        EndDateHH: this.vo.EndDateHH,
        EndDateMI: this.vo.EndDateMI,
        BannerFileNameBfBB: this.vo.BannerFileNameBfBB,
        BannerCaptionBfBB: this.vo.BannerCaptionBfBB,
        BannerFileNameOnBB: this.vo.BannerFileNameOnBB,
        BannerCaptionOnBB: this.vo.BannerCaptionOnBB,
        BannerFileNameAfBB: this.vo.BannerFileNameAfBB,
        BannerCaptionAfBB: this.vo.BannerCaptionAfBB,
        BannerFileNameBfMB: this.vo.BannerFileNameBfMB,
        BannerCaptionBfMB: this.vo.BannerCaptionBfMB,
        BannerFileNameOnMB: this.vo.BannerFileNameOnMB,
        BannerCaptionOnMB: this.vo.BannerCaptionOnMB,
        BannerFileNameAfMB: this.vo.BannerFileNameAfMB,
        BannerCaptionAfMB: this.vo.BannerCaptionAfMB,
        UpdateDate: this.vo.UpdateDate,
        BannerFileNameBfSP: this.vo.BannerFileNameBfSP,
        BannerCaptionBfSP: this.vo.BannerCaptionBfSP,
        BannerFileNameOnSP: this.vo.BannerFileNameOnSP,
        BannerCaptionOnSP: this.vo.BannerCaptionOnSP,
        BannerFileNameAfSP: this.vo.BannerFileNameAfSP,
        BannerCaptionAfSP: this.vo.BannerCaptionAfSP,
        ConfirmFlg: this.vo.ConfirmFlg
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW6501Model} model
   * @param {string} orderCode
   * @param {string} categoryLevel
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof UpdateCwsTimeSaleInfo
   */
  execute(model: KYMW6501Model, vo: TimeSaleDataModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('updateCwsTimeSaleInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateCwsTimeSaleInfo
   */
  success(data: any) {
    this.model.kymw6501Component.updateSuccess(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
